import { DateUtilities, isDefined } from '@evorait/pace-core';
import { OdataHistoricalValue } from '../services/forms-odata.interface';
import { HistoricalValue } from '../types/historical-value';
import moment from 'moment';

export class HistoricalValueUtilities {
    public static convertODataHistoricalValuesToState(
        odataHistoricalValueSet: OdataHistoricalValue[] | undefined,
    ): HistoricalValue[] {
        if (!isDefined(odataHistoricalValueSet)) {
            return [];
        }

        return odataHistoricalValueSet.map((historicalValueSet) => ({
            uniqueId: historicalValueSet.UniqueId,
            value: historicalValueSet.Value,
            date: DateUtilities.formatDate(moment.utc(historicalValueSet.Timestamp)),
            id: `${historicalValueSet.Timestamp}-${historicalValueSet.UniqueId}`,
        }));
    }
}
